import Company from '../components/Company'

export default Company;